


import React, { useState, useEffect } from 'react';
import {
    Grid,
    Switch,
    Button,
    Box,
    Typography,
} from '@mui/material';
import Routes from '../../../routes';
import { trakrefBlue } from '../../../color_utils';
import Select from "../../Common/Select";
import Input from '../../Common/InputField';
import DateInput from '../../Common/DateInput';
import CommonModal from '../../Common/CommonModal';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import toast from 'react-hot-toast';
import CodeConvert from '../../../Utils/DropDownConvert';


const UpdateProposalModal = ({ payload, modalOpen, onClose, refreshRequired, proposalData }) => {
    const [proposedWork, setProposedWork] = useState(null);
    const [terms, setTerms] = useState(null);
    const [laborCost, setLaborCost] = useState(null);
    const [otherCost, setOtherCost] = useState(null);
    const [materialCost, setMaterialCost] = useState(null);
    const [approveByOptions, setApprovedByOptions] = useState([])
    const [approvedBy, setApprovedBy] = useState(null)
    const [approveNotes,setApproveNotes] = useState(null)
    const [approvalDate, setApprovalDate] = useState(null)
    const [approved, setApproved] = useState(null)

    const [step, setStep] = useState(1);

    const [primaryTechError, setPrimaryTechError] = useState(null)


    useEffect(() => {
        if (proposalData.Approvers) {
            setApprovedByOptions(CodeConvert.ConverUser(proposalData.Approvers))
        }
        if (proposalData) {
            setLaborCost(proposalData.LaborCost)
            setOtherCost(proposalData.OtherCost)
            setMaterialCost(proposalData.MaterialCost)
            setProposedWork(proposalData.ProposedWork)
            setTerms(proposalData.Terms)
        }
    }, [modalOpen])


    var Validated = () => {
        //ID and PrimaryTechID are required
        var isValid = true

        return isValid
    }

    var ConfirmProposalUpdate = async () => {

        const ApproveBody = {
            ID: payload.ID,
            ProposedWork: proposedWork,
            Terms: terms,
            LaborCost: laborCost,
            MaterialCost: materialCost,
            OtherCost: otherCost,
            ApprovalNotes: approveNotes,
            ApprovedBy: approvedBy,
            ApprovedDate: approvalDate
        }

        const RejectBody = {
            ID: payload.ID,
            ProposedWork: proposedWork,
            Terms: terms,
            LaborCost: laborCost,
            MaterialCost: materialCost,
            OtherCost: otherCost,
        }

        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
        }

        if (approved) {
            postConfig.body = JSON.stringify(ApproveBody)
            const UpdateResponse = await fetch(Routes.WorkOrder.ApproveProposal(), postConfig)
            if (UpdateResponse.status == 200) {
                onClose()
                refreshRequired()
            }
        } else {
            postConfig.body = JSON.stringify(RejectBody)
            const UpdateResponse = await fetch(Routes.WorkOrder.RejectProposal(), postConfig)
            if (UpdateResponse.status == 200) {
                toast.success('The proposal has been successfully updated.', { duration: 6000 });
                onClose()
                refreshRequired()
            }
        }
    }

    return (
        <CommonModal open={modalOpen} close={onClose} header={`Update Proposal #${payload.ID}`} icon={step == 2 ? <ArrowBackIosIcon /> : null} iconClicked={() => setStep(1)}>
            {
                step == 1 && (
                    <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                            <Input
                                fullWidth
                                variant="outlined"
                                label="Labor Cost"
                                type={'number'}
                                value={laborCost}
                                onChange={e => setLaborCost(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                            <Input
                                fullWidth
                                variant="outlined"
                                type={'number'}
                                label="Other Cost"
                                value={otherCost}
                                onChange={e => setOtherCost(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                            <Input
                                fullWidth
                                variant="outlined"
                                type={'number'}
                                label="Material Cost"
                                value={materialCost}
                                onChange={e => setMaterialCost(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='left'>
                            <Typography sx={{ padding: '1% 0%', fontSize: 17, fontWeight: 600 }}>
                                Total Cost ($) : ${+parseInt(laborCost || 0) + +parseInt(otherCost || 0) + +parseInt(materialCost | 0)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={12} align='center'>
                            <Box mt={2} mb={2} sx={{ width: '100%' }}>
                                <Button
                                    fullWidth
                                    size='large'
                                    variant='contained'
                                    onClick={() => setStep(2)}
                                    style={{
                                        backgroundColor: trakrefBlue
                                    }}
                                >
                                    <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                        NEXT
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>

                    </Grid>
                )
            }
            {
                step == 2 && (
                    <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                            <Input
                                fullWidth
                                variant="outlined"
                                label="Proposed Work"
                                type={'text'}
                                value={proposedWork}
                                onChange={e => setProposedWork(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                            <Input
                                fullWidth
                                variant="outlined"
                                label="Terms"
                                type={'text'}
                                multiline={true}
                                value={terms}
                                onChange={e => setTerms(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12} mb={2} pt={2} align='center' container direction="row" justifyContent="flex-start" alignItems="center">
                            <Typography style={{ fontSize: '1rem' }}>
                                Reject
                            </Typography>
                            <Switch
                                checked={approved}
                                onChange={e => setApproved(!approved)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                            <Typography style={{ fontSize: '1rem' }}>
                                Approve
                            </Typography>
                        </Grid>
                        {
                            approved && (
                                <>
                                    <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                                        <Input
                                            fullWidth
                                            variant="outlined"
                                            label="Approval Notes"
                                            type={'text'}
                                            multiline={true}
                                            value={approveNotes}
                                            onChange={e => setApproveNotes(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                                        <Select
                                            required
                                            label="Approved By"
                                            options={approveByOptions}
                                            value={approvedBy}
                                            onChange={e =>
                                                setApprovedBy(e.target.value)
                                            }
                                            width={100}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                                        <DateInput
                                            enablePast
                                            required
                                            label="Date Approved"
                                            date={approvalDate}
                                            onChange={e => setApprovalDate(e)}
                                            width={100}
                                        />
                                    </Grid>
                                </>
                            )
                        }
                        <Grid item xs={12} lg={12} align='center'>
                            <Box mt={2} mb={2} sx={{ width: '100%' }}>
                                <Button
                                    fullWidth
                                    size='large'
                                    variant='contained'
                                    onClick={() => ConfirmProposalUpdate()}
                                    style={{
                                        backgroundColor: trakrefBlue
                                    }}
                                >
                                    <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                        UPDATE PROPOSAL
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                )
            }
        </CommonModal>
    );
};


export default UpdateProposalModal;
